<script setup>
  import { onMounted, ref, onBeforeUnmount, computed, getCurrentInstance } from "vue";
  import { storeToRefs } from "pinia";
  import { LoadingOverlay } from "@/components/episto-ui/loading-overlay";
  import { useWeightingsStore } from "@stores/weightings";
  import { useSurveyStore } from "@stores/survey/survey";
  import ThreePanePage from "@templates/ThreePanePage.vue";
  import WeightingList from "@/components/Survey/Weighting/WeightingList.vue";
  import WeightingEdit from "@/components/Survey/Weighting/WeightingEdit.vue";
  import WeightingInfo from "@/components/Survey/Weighting/WeightingInfo.vue";

  const weightingsStore = useWeightingsStore();
  const { selectedWeightingIndex, selectedWeighting, saveAttempted } = storeToRefs(weightingsStore);
  const { fetchWeightings, weightsChannelHandlers } = weightingsStore;

  const surveyStore = useSurveyStore();
  const { survey } = storeToRefs(surveyStore);

  const instance = getCurrentInstance();
  const cable = instance.proxy.$cable;

  const isFirstLoaded = ref(false);
  const isLoading = ref(false);
  const isNotCompletedPausedLive = computed(() => !["live", "paused", "complete"].includes(survey.value.status));

  onMounted(async () => {
    if (["live", "paused", "complete"].includes(survey.value.status)) {
      isLoading.value = true;
      await fetchWeightings();
      isLoading.value = false;
      isFirstLoaded.value = true;

      cable.subscribe({ channel: "WeightsChannel", survey_token: survey.value.token });
      cable._addChannel("WeightsChannel", weightsChannelHandlers(cable, survey.value.token), {
        _uid: instance.uid,
        _value: instance.proxy,
      });
    }
  });

  onBeforeUnmount(async () => {
    cable.unsubscribe("WeightsChannel");
    selectedWeighting.value = null;
    selectedWeightingIndex.value = 0;
    saveAttempted.value = false;
  });
</script>

<template>
  <div data-cy="survey-weighting-page">
    <LoadingOverlay
      v-if="isLoading"
      text="Loading..." />
    <div
      v-if="isNotCompletedPausedLive"
      class="flex justify-center">
      <span>Your survey must be completed, paused or live</span>
    </div>
    <ThreePanePage v-else>
      <template #left>
        <WeightingList />
      </template>
      <template #center>
        <WeightingEdit :is-first-loaded="isFirstLoaded" />
      </template>
      <template #right>
        <WeightingInfo />
      </template>
    </ThreePanePage>
  </div>
</template>
